import React from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {CloseIcon} from '../common/Icons';
import {EnquiryForm} from '../common/EnquiryForm';

interface ContactModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const ContactModal: React.FC<ContactModalProps> = ({isOpen, onClose}) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
                    onClick={onClose}
                >
                    <motion.div
                        initial={{scale: 0.9, opacity: 0}}
                        animate={{scale: 1, opacity: 1}}
                        exit={{scale: 0.9, opacity: 0}}
                        className="bg-ivory rounded-lg shadow-xl max-w-lg w-full relative"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 text-royal-pine hover:text-logo-color transition-colors"
                        >
                            <CloseIcon className="w-6 h-6"/>
                        </button>
                        <div className="py-6 px-4">
                            <EnquiryForm forModal={true}/>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
